export default __webpack_public_path__ + "static/media/general-computer.db4348eb.jpg";